import axios from 'axios';
import { useEffect, useState } from 'react';
import Footer from './Footer.js';
import CardGallery from './CardGallery.js';


const Galeria = () => {
    const [usersRegistered, setusersRegistered] = useState(null);
    const [lastPageUrl, setlastPageUrl] = useState(null);
    const [firstPageUrl, setfirstPageUrl] = useState(null);
    const [lastPage, setLastPage] = useState(null);
    const [nextPage, setNextPage] = useState(null);
    const [prevPage, setPrevPage] = useState(null);
    const [numberCard, setnumberCard] = useState(0);
    const [positionSlide, setPositionSlide] = useState(0);
    const [currentPosition, setCurrentPosition] = useState(0);
    const [loader, setLoader] = useState(true);
    useEffect(() => {
        var ahora = new Date();
        var milisegundos = ahora.getMilliseconds();
        setLoader(false)
        axios({
            url: process.env.REACT_APP_API + "/api/christmas/microsite/" + process.env.REACT_APP_SITE_ID + "/gallery" + "?v=" +
                milisegundos,
            method: "GET",
        })
            .then((response) => {

                setusersRegistered(response.data.data);
                setfirstPageUrl(response.data.data.first_page_url);
                setlastPageUrl(response.data.data.last_page_url);
                setLastPage(response.data.data.last_page);
                setnumberCard(response.data.data.total);
                setNextPage(response.data.data.next_page_url);
                setPrevPage(response.data.data.prev_page_url);
                setCurrentPosition(response.data.data.current_page);
                setLoader(true)
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);


    function updateData(url) {
        setLoader(false)
        var ahora = new Date();
        var milisegundos = ahora.getMilliseconds();
        axios({
            url: url + "&v=" + milisegundos,
            method: "GET",
        })
            .then((response) => {

                setusersRegistered(response.data.data);
                setfirstPageUrl(response.data.data.first_page_url);
                setlastPageUrl(response.data.data.last_page_url);
                setLastPage(response.data.data.last_page);
                setNextPage(response.data.data.next_page_url);
                setPrevPage(response.data.data.prev_page_url);
                setCurrentPosition(response.data.data.current_page);
                setLoader(true)
            })
            .catch((e) => {
                console.error(e);
            });
    }

    function nextPageSlider(url) {
        setLoader(false)
        var ahora = new Date();
        var milisegundos = ahora.getMilliseconds();

        axios({
            url: url + "&v=" + milisegundos,
            method: "GET",
        })
            .then((response) => {

                setusersRegistered(response.data.data);
                setfirstPageUrl(response.data.data.first_page_url);
                setlastPageUrl(response.data.data.last_page_url);
                setLastPage(response.data.data.last_page);
                setNextPage(response.data.data.next_page_url);
                setPrevPage(response.data.data.prev_page_url);
                setCurrentPosition(response.data.data.current_page);
                setLoader(true)

            })
            .catch((e) => {
                console.error(e);
            });
    }
    function prevPageSlider(url) {
        setLoader(false)
        var ahora = new Date();
        var milisegundos = ahora.getMilliseconds();

        axios({
            url: url + "&v=" + milisegundos,
            method: "GET",
        })
            .then((response) => {

                setusersRegistered(response.data.data);
                setfirstPageUrl(response.data.data.first_page_url);
                setlastPageUrl(response.data.data.last_page_url);
                setLastPage(response.data.data.last_page);
                setNextPage(response.data.data.next_page_url);
                setPrevPage(response.data.data.prev_page_url);
                setCurrentPosition(response.data.data.current_page);
                setLoader(true)
            })
            .catch((e) => {
                console.error(e);
            });
    }

    const paginationNumber = () => {
        let button = [];
        for (let i = 1; i <= lastPage; i++) {
            button.push(<button disabled={lastPage > 1 ? false : true} className={currentPosition === i ? 'page-link active' : 'page-link'} onClick={() => updateData(process.env.REACT_APP_API+"/api/christmas/microsite/"+process.env.REACT_APP_MICROSITE_ID+"/gallery?page=" + i)}>
                <li className="page-item">{i}</li>
            </button>);
        }
        return button;
    }

    return (
        <>
            <div className="fondoBases pb-5">
                <div className="container">
                    <div className="containner text-center">
                        <h1 className="pt-5 mb-5 tituloBases">GALERÍA</h1>
                    </div>
                    {loader ?
                        <div className="mb-5">
                            {numberCard > 0 ? (
                                <div className="">
                                    <CardGallery data={usersRegistered} />
                                    <nav className="pb-5" >
                                        <ul className="pagination justify-content-center ">
                                            <button
                                                className="page-link"
                                                onClick={() => updateData(firstPageUrl, setPositionSlide(0))}
                                                disabled={currentPosition === 1 ? true : false}
                                            >
                                                <li className="page-item">
                                                    {"<<"}
                                                </li>
                                            </button>
                                            <button
                                                className="page-link"
                                                onClick={() => prevPageSlider(prevPage, setPositionSlide(positionSlide + 2))}
                                                disabled={currentPosition === 1 ? true : false}
                                            >
                                                <li className="page-item">
                                                    {"<"}
                                                </li>
                                            </button>
                                            <div className="paginationContainer d-flex">
                                                <div className="d-flex paginationSlider" style={{ transform: 'translateX(' + positionSlide + 'rem)', widows: positionSlide + 'rem' }}>
                                                    {paginationNumber()}
                                                </div>
                                            </div>

                                            <button
                                                className={currentPosition >= 1 ? 'd-block page-link' : 'd-none page-link'}
                                                onClick={() => nextPageSlider(nextPage, setPositionSlide(positionSlide - 2))}
                                                disabled={currentPosition === lastPage ? true : false}
                                            >
                                                <li className="page-item">
                                                    {">"}
                                                </li>
                                            </button>
                                            <button
                                                className="page-link"
                                                onClick={() => updateData(lastPageUrl, setPositionSlide((lastPage - 2)))}
                                                disabled={lastPage > 1 ? false : true}
                                            >
                                                <li className="page-item">
                                                    {">>"}
                                                </li>
                                            </button>
                                        </ul>
                                    </nav>
                                </div>
                            ) : (
                                <div className="gallery_noData">
                                </div>
                            )}
                        </div>
                        :
                        <div className="d-flex justify-content-center">
                            <div className="lds-facebook text-center"><div></div><div></div><div></div></div>
                        </div>
                    }

                </div>
            </div>
            <Footer />
        </>
    );
};

export default Galeria;